const MAX_ENTRIES = 8;
const listeners = new Set();
let entries = [];

function notify() {
  listeners.forEach((fn) => fn([...entries]));
}

export function subscribeDevApiDebug(listener) {
  listeners.add(listener);
  listener([...entries]);
  return () => listeners.delete(listener);
}

export function logDevApiError(error, source = 'api') {
  if (process.env.NODE_ENV === 'production') return;

  const config = error?.config || {};
  const method = (config.method || 'get').toUpperCase();
  const baseURL = config.baseURL || '';
  const url = config.url || '';
  const fullUrl = url.startsWith('http') ? url : `${baseURL}${url}`;

  const entry = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    at: new Date().toLocaleTimeString(),
    source,
    method,
    url: fullUrl,
    status: error?.response?.status ?? null,
    message: error?.response?.data?.error
      || error?.response?.data?.message
      || error?.message
      || 'Unknown error',
    code: error?.code || null
  };

  entries = [entry, ...entries].slice(0, MAX_ENTRIES);
  notify();
}

export function clearDevApiDebug() {
  entries = [];
  notify();
}
